import { PATHS } from '../configs';
import client from '../services/client';

import type { ChainStoreInvoice, SupportReceiptType } from '../types';

type GetJKOPayInitUrlProps = {
  invoice: ChainStoreInvoice;
  email: string | undefined;
  receipt: {
    name: string;
    phone: string;
    barcode?: string;
    type: SupportReceiptType;
    ubn?: string;
    donate?: string;
  };
  callbackParams: {
    serviceUid: string;
    captureMethod: string;
    amount: string;
    merchantUid: string;
  };
};

export const getJKOPayInitUrl = async ({
  invoice,
  email,
  receipt,
}: GetJKOPayInitUrlProps) => {
  const {
    data: {
      data: { redirect_link },
    },
  } = await client.initJKOPayTransaction({
    invoiceId: invoice.id,
    email,
    receipt,
    callbackUrl: `${window.location.origin}${PATHS.INVOICES(invoice.id).AUTH.JKOPAY}`,
  });

  return redirect_link;
};
